import React, { useEffect, useMemo, useState } from "react";
import { formatCurrency } from "./Format";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";

const parseCurrency = (v) => {
    if (v == null) return 0;

    const s = String(v)
        .trim()
        .replace(/\s/g, "")
        .replace("€", "")
        .replace(",", ".");

    const n = Number(s);
    return Number.isFinite(n) ? n : 0;
};

const toYMDLocal = (d) => {
    if (!d) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
};

const parseYMDLocal = (s) => {
  if (!s) return null;
  const str = String(s).trim();

  // cas "0000-00-00" = pas de date
  if (str === "0000-00-00") return null;

  const m = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;

  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);

  if (!y || mo < 1 || mo > 12 || d < 1 || d > 31) return null;

  return new Date(y, mo - 1, d); // ✅ local (pas UTC)
};


// Date -> "JJ/MM/AAAA"
export const formatFRDate = (d) => {
    if (!d) return "";
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
};


const FormattedInput = ({ value, onChange, type = "currency", className = "" }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [raw, setRaw] = useState("");

    const displayValue = useMemo(() => {
        if (isEditing) return raw;
        return formatCurrency(value ?? 0);
    }, [isEditing, raw, value]);

    useEffect(() => {
        if (type !== "currency") return;
        if (!isEditing) setRaw(value == null ? "" : String(value));
    }, [value, isEditing, type]);

    if (type === "date") {
        return (
            <DatePickerComponent
                value={parseYMDLocal(value)}
                format="dd/MM/yyyy"
                placeholder="Sélectionner une date"
                onChange={(e) => onChange(e.value ? formatFRDate(e.value) : "")}
                className={className}
            />
        );
    }

    if (type === "text") {
        return (
            <input
                type="text"
                value={raw}
                onChange={(e) => setRaw(e.target.value)}
                onFocus={() => setIsEditing(true)}
                onBlur={() => {
                    setIsEditing(false);
                    onChange(raw);
                }}
                className={`border-gray-300 p-1 cursor-pointer border rounded focus:ring-2 ring-orange-500 text-center outline-none ${className}`}
            />
        );
    }

    return (
        <input
            type="text"
            inputMode="decimal"
            value={displayValue}
            onFocus={() => {
                setIsEditing(true);
                setRaw(value == null ? "" : String(value));
            }}
            onChange={(e) => {
                const next = e.target.value.replace(/[^\d.,-]/g, "");
                setRaw(next);
            }}
            onBlur={() => {
                setIsEditing(false);
                const n = parseCurrency(raw);
                onChange(n);
            }}
            className={`border-gray-300 p-1 cursor-pointer border rounded focus:ring-2 text-center outline-none ${className}`}
        />
    );
};

export default FormattedInput;
